module.exports = function() {
  return new Worker(__webpack_public_path__ + "2c679071841c1f94eafe.worker.js");
};